import React from 'react'
import HeaderOne from '@/components/header-one'
import Layout from '@/components/layout'
import PageHeader from '@/components/page-header'
import Footer from '@/components/footer'
import MenuContextProvider from '@/context/menu-context'
import PartitionProducts from '@/components/Products/PartitionProducts'

const ModularKitchen = () => {
  return (
    <MenuContextProvider>
      <Layout PageTitle="Partition">
        <HeaderOne />
        <PageHeader title="Partition" name="Products" subRoute="Partition" />
        <PartitionProducts />
        <Footer />
      </Layout>
    </MenuContextProvider>
  )
}

export default ModularKitchen
